import Api from './Api';

export default {
  create: (data, payLinkKey) => Api.post(`/v1/payments/pay?key=${payLinkKey}`, data),
};
